__turbopack_context__.v({
  "clearFilters": "CFacture-module__PkGs_a__clearFilters",
  "comments": "CFacture-module__PkGs_a__comments",
  "filterField": "CFacture-module__PkGs_a__filterField",
  "filters": "CFacture-module__PkGs_a__filters",
  "note": "CFacture-module__PkGs_a__note",
  "num": "CFacture-module__PkGs_a__num",
  "pageButton": "CFacture-module__PkGs_a__pageButton",
  "pageInfo": "CFacture-module__PkGs_a__pageInfo",
  "pagination": "CFacture-module__PkGs_a__pagination",
  "paid": "CFacture-module__PkGs_a__paid",
  "pdfBtn": "CFacture-module__PkGs_a__pdfBtn",
  "pdfIcon": "CFacture-module__PkGs_a__pdfIcon",
  "root": "CFacture-module__PkGs_a__root",
  "searchWrap": "CFacture-module__PkGs_a__searchWrap",
  "sentInfo": "CFacture-module__PkGs_a__sentInfo",
  "sortIcon": "CFacture-module__PkGs_a__sortIcon",
  "sortIconActive": "CFacture-module__PkGs_a__sortIconActive",
  "table": "CFacture-module__PkGs_a__table",
  "tableWrap": "CFacture-module__PkGs_a__tableWrap",
  "thInner": "CFacture-module__PkGs_a__thInner",
  "thSortable": "CFacture-module__PkGs_a__thSortable",
  "toolbar": "CFacture-module__PkGs_a__toolbar",
  "truncatedHint": "CFacture-module__PkGs_a__truncatedHint",
  "unpaid": "CFacture-module__PkGs_a__unpaid",
});
